// 获取极验初始化接口
export const getGInit = ({ phone, countryCode }) => {
  return {
    url: '/api/over-sea-sms/gt-init',
    method: 'post',
    data: {
      phone,
      countryCode,
    },
  };
};

export default {
  getGInit,
};
